var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newAccount(data) {
    var instance = {
        __type: "Account:#DecisionsFramework.ServiceLayer.Services.Accounts",
        LanguageName: null,
        FirstName: null,
        MiddleInitial: null,
        LastName: null,
        Initials: null,
        NickName: null,
        UserCulture: null,
        JobTitle: null,
        SecurityQuestion: null,
        SecurityAnswer: null,
        SecurityQuestion2: null,
        SecurityAnswer2: null,
        SecurityQuestion3: null,
        SecurityAnswer3: null,
        TimezoneName: null,
        AccountPictureID: null,
        NumberOfAttempts: 0,
        LastPasswordResetDate: new Date('0001-01-01T00:00:00Z'),
        AccountID: null,
        EmployeeID: null,
        Department: null,
        DepartmentNumber: null,
        Company: null,
        IsActive: true,
        IsConfirmed: true,
        NeverExpires: false,
        CanUsePortal: true,
        IsTwoFactorAuthenticationEnabled: false,
        EmailAddress: null,
        UserType: 0 /* AccountType.Machine */,
        AuthenticationType: 0 /* UserAuthenticationType.ActiveDirectory */,
        DefaultFolderId: null,
        HomeFolderID: null,
        SourceSystemId: null,
        LastUSN: 0,
        DistinguishedName: null,
        SID: null,
        UserIdentifier: null,
        PermittedIPAddresses: null,
        LocationId: null,
        MustChangePasswordOnNextLogin: false,
        Theme: null,
        LastLoginDate: null,
        FirstLoginDate: null,
        IdentityProviderID: null,
        Hidden: false,
        AdministratorViewOnly: false,
        EntityFolderID: null,
        HistoryFolderID: null,
        AllTagsData: null,
        EntityName: null,
        EntityDescription: null,
        State: null,
        CreatedOnDate: new Date('0001-01-01T00:00:00Z'),
        ModifiedDate: new Date('0001-01-01T00:00:00Z'),
        CreatedBy: null,
        ModifiedBy: null,
        Archived: false,
        ArchivedBy: null,
        ArchivedDate: new Date('0001-01-01T00:00:00Z'),
        Deleted: false,
        DeletedBy: null,
        DeletedOn: new Date('0001-01-01T00:00:00Z'),
        CustomLongDescription: null,
        CustomShortDescription: null
    };
    return __assign(__assign({}, instance), data);
}
export function isAccount(object) {
    return object.__type === "Account:#DecisionsFramework.ServiceLayer.Services.Accounts";
}
